import type { EditorCommand, ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { MalleableUiPlugin } from '../malleableUiPluginType';
import { malleableUiPluginKey } from '../pm-plugins/plugin-key';

export const makeCloseRemixModal =
	(api: ExtractInjectionAPI<MalleableUiPlugin> | undefined) =>
	(): EditorCommand =>
	({ tr }) => {
		// Clear the block selection so stale ak-editor-selected-node decorations
		// are removed when the modal is dismissed.
		api?.selection?.commands?.clearBlockSelection()({ tr });
		tr.setMeta(malleableUiPluginKey, {
			isRemixModalOpen: false,
			remixModalMetadata: undefined,
			remixSource: undefined,
		});
		return tr;
	};
